
import AlertDialogOnClose from "../../../../components/admin/AlertDiologOnClose";
import ListaBombaVacuo from "./ListaBombaVacuo";
export default function BombaVacuoForm() {
    return (
        <AlertDialogOnClose nome={"Bomba de Vácuo"} placeholder={"Insira o nome da bomba"}>
            <ListaBombaVacuo />
        </AlertDialogOnClose>
    )
} 